import { ProductionLine } from "./productionLine";

export interface Workstation {
  id?: string;
  position: number;
  created_at?: string;
  created_by?: string;
  name: string;
  production_line: ProductionLine;
  production_line_index: number;
  is_active: boolean;
  description?: string;
  activeReports?: Report[];
  reports?: Report[];
  escalatedReports?: Report[];
}

export interface WorkstationDB {
  id?: string;
  position: number;
  created_at?: string;
  created_by?: string;
  name: string;
  production_line: string;
  production_line_index: number;
  is_active: boolean;
  description?: string;
}

export function transformWorkstationForDatabase(
  workstation: Workstation
): WorkstationDB {
  return {
    id: workstation.id,
    name: workstation.name,
    position: workstation.position,
    production_line: workstation.production_line.id!,
    production_line_index: workstation.production_line_index,
    is_active: workstation.is_active,
    description: workstation.description,
  };
}
